import 'react-app-polyfill/ie9'
import React from 'react'
import { render } from 'react-dom'
import Loadable from 'react-loadable'
import { Provider } from 'react-redux'
import FastClick from 'react-fastclick-alt'

import Router from './rootRoute'
import TokenToolRouter from './tokenToolRoute'

import register from './utils/registerServiceWorker'
import store from './redux/store'
import InitTrezor from './utils/integrations/trezor'
import { MatomoLoader } from './matomo'

import './phishing/check'

import './static/styles/iconfont.css'
import './static/styles/index.css'
import { isTokenManagementEnabled } from './utils/isTokenManagementEnabled'

const Root = (
  <FastClick>
    <MatomoLoader />
    <Provider store={store}>{isTokenManagementEnabled ? <TokenToolRouter /> : <Router />}</Provider>
  </FastClick>
)

Loadable.preloadReady().then(() => {
  render(Root, document.getElementById('root'))
})

window.__DEV__ = process.env.NODE_ENV !== 'production'
window.__isTokenTool__ = process.env.REACT_APP_IS_TOKEN_TOOL

register()

InitTrezor()
